var map = {
	"./avatar.svg": 437,
	"./db-logos/Cassandra.png": 1777,
	"./db-logos/athena.png": 1778,
	"./db-logos/aws_es.png": 1779,
	"./db-logos/axibasetsd.png": 1780,
	"./db-logos/azure_kusto.png": 1781,
	"./db-logos/bigquery.png": 1782,
	"./db-logos/bigquery_gce.png": 1783,
	"./db-logos/clickhouse.png": 1784,
	"./db-logos/cloudwatch.png": 1785,
	"./db-logos/cloudwatch_insights.png": 1786,
	"./db-logos/cockroach.png": 1787,
	"./db-logos/corporate_memory.png": 1788,
	"./db-logos/couchbase.png": 1789,
	"./db-logos/csv.png": 1790,
	"./db-logos/databricks.png": 1791,
	"./db-logos/db2.png": 1792,
	"./db-logos/dgraph.png": 1793,
	"./db-logos/drill.png": 1794,
	"./db-logos/druid.png": 1795,
	"./db-logos/dynamodb_sql.png": 1796,
	"./db-logos/elasticsearch.png": 1797,
	"./db-logos/exasol.png": 1798,
	"./db-logos/excel.png": 1799,
	"./db-logos/firebolt.png": 1800,
	"./db-logos/google_analytics.png": 1801,
	"./db-logos/google_spreadsheets.png": 1802,
	"./db-logos/graphite.png": 1803,
	"./db-logos/hive.png": 1804,
	"./db-logos/hive_http.png": 1805,
	"./db-logos/impala.png": 1806,
	"./db-logos/influxdb.png": 1807,
	"./db-logos/jirajql.png": 1808,
	"./db-logos/json.png": 1809,
	"./db-logos/kibana.png": 1810,
	"./db-logos/kylin.png": 1811,
	"./db-logos/mapd.png": 1812,
	"./db-logos/memsql.png": 1813,
	"./db-logos/mongodb.png": 1814,
	"./db-logos/mssql.png": 1815,
	"./db-logos/mssql_odbc.png": 1816,
	"./db-logos/mysql.png": 1817,
	"./db-logos/oracle.png": 1818,
	"./db-logos/pg.png": 1819,
	"./db-logos/phoenix.png": 1820,
	"./db-logos/presto.png": 1821,
	"./db-logos/prometheus.png": 1822,
	"./db-logos/python.png": 1823,
	"./db-logos/qubole.png": 1824,
	"./db-logos/rds_mysql.png": 1825,
	"./db-logos/redshift.png": 1826,
	"./db-logos/redshift_iam.png": 1827,
	"./db-logos/results.png": 1828,
	"./db-logos/rockset.png": 1829,
	"./db-logos/salesforce.png": 1830,
	"./db-logos/scylla.png": 1831,
	"./db-logos/snowflake.png": 1832,
	"./db-logos/sparql_endpoint.png": 1833,
	"./db-logos/sqlite.png": 1834,
	"./db-logos/treasuredata.png": 1835,
	"./db-logos/trino.png": 1836,
	"./db-logos/uptycs.png": 1837,
	"./db-logos/url.png": 1838,
	"./db-logos/vertica.png": 1839,
	"./db-logos/yandex_appmetrika.png": 1840,
	"./db-logos/yandex_metrika.png": 1841,
	"./destinations/chatwork.png": 1842,
	"./destinations/email.png": 1843,
	"./destinations/hangouts_chat.png": 1844,
	"./destinations/hipchat.png": 1845,
	"./destinations/mattermost.png": 1846,
	"./destinations/pagerduty.png": 1847,
	"./destinations/slack.png": 1848,
	"./destinations/webhook.png": 1849,
	"./favicon-16x16.png": 1850,
	"./favicon-32x32.png": 1851,
	"./favicon-96x96.png": 1852,
	"./fixtures/map-tile.png": 1853,
	"./google_logo.svg": 1854,
	"./illustrations/alert.svg": 1855,
	"./illustrations/dashboard.svg": 1856,
	"./illustrations/no-query-results.svg": 1857,
	"./illustrations/query.svg": 1858,
	"./logo.png": 1859,
	"./logo_white.png": 1860,
	"./redash_icon_small.png": 103
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1776;